"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Text = void 0;
var react_1 = __importDefault(require("react"));
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
var Text = function (props) {
    var _a = props.as, as = _a === void 0 ? 'p' : _a, dangerous = props.dangerous, body = props.body, className = props.className, rest = __rest(props, ["as", "dangerous", "body", "className"]);
    return dangerous ? (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as, className: ['text', className], dangerouslySetInnerHTML: {
            __html: body
        } }, rest))) : (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as, className: ['text', className] }, rest), body));
};
exports.Text = Text;
//# sourceMappingURL=Text.js.map